var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 1.75C11.3928 1.75 11.6895 1.87292 11.9083 2.09171C12.1271 2.3105 12.25 2.60725 12.25 2.91667V11.0833C12.25 11.3928 12.1271 11.6895 11.9083 11.9083C11.6895 12.1271 11.3928 12.25 11.0833 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V2.91667C1.75 2.60725 1.87292 2.3105 2.09171 2.09171C2.3105 1.87292 2.60725 1.75 2.91667 1.75H11.0833ZM10.7917 10.7917V7.7C10.7917 7.19565 10.5913 6.71195 10.2347 6.35532C9.87805 5.99869 9.39435 5.79833 8.89 5.79833C8.39417 5.79833 7.81667 6.10167 7.53667 6.55667V5.90917H5.90917V10.7917H7.53667V7.91583C7.53667 7.46667 7.89833 7.09917 8.3475 7.09917C8.56409 7.09917 8.77182 7.18521 8.92497 7.33836C9.07812 7.49152 9.16417 7.69924 9.16417 7.91583V10.7917H10.7917ZM4.01333 4.99333C4.27325 4.99333 4.52251 4.89008 4.7063 4.7063C4.89008 4.52251 4.99333 4.27325 4.99333 4.01333C4.99333 3.47083 4.55583 3.0275 4.01333 3.0275C3.75187 3.0275 3.50112 3.13136 3.31624 3.31624C3.13136 3.50112 3.0275 3.75187 3.0275 4.01333C3.0275 4.55583 3.47083 4.99333 4.01333 4.99333ZM4.82417 10.7917V5.90917H3.20833V10.7917H4.82417Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.72be9fc43a56e8aa061f491c76b1ed6b.svg";
export { ForwardRef as ReactComponent };